<template>
  <div class="salary">
    <el-page-header @back="goBack" title content="工资通知"></el-page-header>
    <div class="salary_form">
      <el-form ref="form" :model="salary" label-width="160px">
        <el-form-item label="工资发放年/月:">
          <el-date-picker v-model="salary.date" type="month" placeholder="选择月"></el-date-picker>
        </el-form-item>
        <el-form-item label="工资表Excel:">
          <div class="el-upload el-upload--text" ref="triggerArea" @click="triggerUpload">
            <div class="el-upload-dragger" v-if="!salary.file">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
            </div>
            <div class="el-upload-dragger" v-else>
              <div class="file_name">
                <i class="iconfont icon-lianjie"></i>
                {{salary.file.name}}
              </div>
            </div>
            <input type="file" hidden ref="upload" @change="upload" />
            <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </div>
        </el-form-item>
        <el-form-item>
          <el-button>取消</el-button>
          <el-button type="primary" @click="submit">确定</el-button>
        </el-form-item>
        <el-form-item label="发送通知:">
          <el-button type="primary" @click="sendMessage">发送通知</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Salary",
  data() {
    return {
      salary: {
        date: "",
        file: null
      }
    };
  },
  mounted: function() {
    this.addDragEventListener();
  },
  methods: {
    addDragEventListener: function() {
      let dropZone = this.$refs.triggerArea;
      dropZone.addEventListener(
        "dragenter",
        e => {
          e.preventDefault();
          e.stopPropagation();
        },
        false
      );

      dropZone.addEventListener(
        "dragover",
        e => {
          e.preventDefault();
          e.stopPropagation();
        },
        false
      );

      dropZone.addEventListener(
        "dragleave",
        e => {
          e.preventDefault();
          e.stopPropagation();
        },
        false
      );

      dropZone.addEventListener(
        "drop",
        e => {
          e.preventDefault();
          e.stopPropagation();
          // 处理拖拽文件的逻辑
          this.drag(e);
        },
        false
      );
    },
    drag: function(e) {
      var df = e.dataTransfer;
      if (df.items !== undefined) {
        // 用webkitGetAsEntry禁止上传目录
        var item = df.items[0];
        if (item.kind === "file" && item.webkitGetAsEntry().isFile) {
          var file = item.getAsFile();
          this.salary.file = file;
        }
      } else {
        this.salary.file = df.files[0];
      }
    },
    triggerUpload: function() {
      this.$refs.upload.click();
    },
    upload: function(e) {
      this.salary.file = e.target.files[0];
    },
    submit: function() {
      const year = this.salary.date.getFullYear();
      const month = this.salary.date.getMonth() + 1;
      let formData = new FormData();
      formData.append("file", this.salary.file);
      this.$api
        .post(`/xsss/v1/salary?year=${year}&month=${month}`, formData)
        .then(() => {
          this.$message({
            message: "导入成功",
            type: "success"
          });
        });
    },
    sendMessage: function() {
      const year = this.salary.date.getFullYear();
      const month = this.salary.date.getMonth() + 1;
      this.$api
        .post(`/xsss/v1/sendMessage?year=${year}&month=${month}`)
        .then(() => {
          this.$message({
            message: "发送成功",
            type: "success"
          });
        });
    },
    goBack: function() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
@import url("./index.css");
</style>